export default __webpack_public_path__ + "static/media/transfer.5f8c8b09.png";